<form (ngSubmit)="onSubmit()" #debateForm="ngForm" class="element-form">
  <div class="row">
    <div class="col-6">
      <h1><strong>Dodawanie debaty</strong></h1>
    </div>
    <div class="col-6">
      <div class="float-right">
        <button mat-stroked-button class="login-button " color="primary" routerLink="/conference/debates-list"
          [state]={page:this.page,pageSize:this.pageSize}>Anuluj</button>
        <button mat-raised-button type="submit" class="ml-1" [disabled]="!debateForm.form.valid"
          color="primary">Dodaj</button>
      </div>
    </div>
  </div>
  <mat-card>
    <mat-card-content>
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field class="w-100">
            <input matInput placeholder="Tytuł" required [(ngModel)]="model.title" name="title" #name="ngModel">
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Element Programu</mat-label>
            <mat-select [(ngModel)]="model.programElementId" #name="ngModel" name="programElementId">
              <mat-option *ngFor="let element of programElements" [value]="element.id">
                <div [innerHTML]="element.name"></div>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-100">
            <input type="datetime-local" matInput placeholder="Godzina" required [(ngModel)]="model.start" name="start"
              #name="ngModel">
          </mat-form-field>
          <mat-form-field class="w-100">
            <input type="datetime-local" matInput placeholder="Godzina" required [(ngModel)]="model.end" name="end"
              #name="ngModel">
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <ckeditor class="w-100" [config]="htmlEditorConfig" [editor]="Editor" data="<p></p>"
            [(ngModel)]="model.description" name="description" #name="ngModel"></ckeditor>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
